export const OPTIMIZE_ROUTES_FAILED = 'OPTIMIZE_ROUTES_FAILED';
export const LIST_OPTIMIZED_ROUTES = 'LIST_OPTIMIZED_ROUTES';
export const LOADING_LIST_ROUTE_FILE = 'LOADING_LIST_ROUTE_FILE';
export const LIST_ROUTE_FILE = 'LIST_ROUTE_FILE';
export const LIST_ROUTE_NOT_OPTIMIZED = 'LIST_ROUTE_NOT_OPTIMIZED';
export const LOADING_LIST_OPTIMIZED_ROUTES = 'LOADING_LIST_OPTIMIZED_ROUTES';
export const LIST_STOP_POINT = 'LIST_STOP_POINT';
export const GO_TO_CREATE_PIBOX = 'GO_TO_CREATE_PIBOX';